import ProspectorProApiService from './ProspectorProApiService';

export default class ActivityService extends ProspectorProApiService {
  getProspectActivity(contactkey, prospectkey) {
    const data = {
      prospectkey,
    };

    return this.get('/ActivityREST/get-prospect-activity/', data, contactkey);
  }

  getAssistantActivityByOAAgentId(oaagentid, data) {
    return this.get('/ActivityREST/prospecting-assistant-activities-for-oaagent/', data, oaagentid);
  }

  getPliteActivityByOAAgentId(oaagentid, data) {
    return this.get('/ActivityREST/plite-activities-for-oaagent/', data, oaagentid);
  }
}
